import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {
  HttpErrorBackend,
  HttpErrorProject,
  PROJECT_API_OPTIONS,
  ProjectApi,
  ProjectApiOptions,
} from '@specials/project-user';

import {userInfoResponse} from '@/resources/mocks';
import {ProjectUserInfoData, ProjectUserLoginData} from '@/services/ProjectAuthApi/types';
import {QueryStringService} from '@/services/QueryStringService/QueryStringService';
import {ApiRoutes, GlobalWindow} from '@/types';

import {HttpClientProjectApi} from '../ProjectApi/ProjectApiHttpClient';

export class ProjectAuthApiMock extends ProjectApi<ProjectUserInfoData, ProjectUserLoginData> {
  constructor(
    private readonly apiRoutes: ApiRoutes,
    private readonly httpClientProjectApi: HttpClientProjectApi,
    private readonly queryString: QueryStringService,
    private readonly globalWindow: GlobalWindow,
  ) {
    // Переопределяем значения, потому что внедрили шаблон CQRS
    // и к эндопинтам авторизации нужно добавлять префиксы /commands и /queries
    const projectApiOptions: ProjectApiOptions = {
      ...PROJECT_API_OPTIONS,
      userInfoUrl: apiRoutes.user.info,
      logoutUrl: apiRoutes.auth.logout,
      loginUrl: apiRoutes.auth.login,
    };

    super(httpClientProjectApi, projectApiOptions, globalWindow.document);
  }

  public hasAuthStatusCookie(): boolean {
    return true;
  }

  public async logout(): Promise<void> {
    return;
  }

  public async login(): Promise<ProjectUserLoginData> {
    return {authToken: ''};
  }

  public async userInfo(): Promise<ProjectUserInfoData> {
    await this.wait(1000);
    // мок ошибки
    const httpCode = this.queryString.getHttpCode();
    const errorCode = this.queryString.getErrorCode();

    if (httpCode === '503') {
      throw new HttpErrorBackend('Service Unavailable', {httpCode: Number(httpCode)});
    }

    if (errorCode && httpCode) {
      throw new HttpErrorProject('Ошибка', {
        httpCode: Number(httpCode),
        errorCode: errorCode,
        errorMessage: 'Error',
        timestamp: new this.globalWindow.Date().toISOString(),
        requestId: 'jnjnf-sdfef33-fdfdfewf33-dvdfvdfv',
      });
    }

    return userInfoResponse;
  }

  private wait(delay: number = 300): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, delay));
  }
}

injected(
  ProjectAuthApiMock,
  DI_TOKENS.apiRoutes,
  DI_TOKENS.httpClientProjectApi,
  DI_TOKENS.queryStringService,
  DI_TOKENS.globalWindow,
);
